import type { OrganisationUnitsTreeDto } from "src/app/features/OrganisationUnitsTree/types/OrganisationUnitsTreeDto";
import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";

export interface OrganisationUnitsTreeChildrenQuery {
    parentId: number;
}

const OrganisationUnitsTreeApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        OrganisationUnitsTreeLoad: builder.query<OrganisationUnitsTreeDto, void>({
            providesTags: [ResourceName.ORGANISATION_UNITS_TREE],
            query: () => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.ORGANISATION_UNITS_TREE}`,
                    method: "GET",
                };
            },
        }),
        OrganisationUnitsTreeLoadChildren: builder.query<OrganisationUnitsTreeDto, OrganisationUnitsTreeChildrenQuery>({
            providesTags: [ResourceName.ORGANISATION_UNITS_TREE],
            query: ({ parentId }) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.ORGANISATION_UNITS_TREE}/${parentId}/children`,
                    method: "GET",
                };
            },
        }),
    }),
});

export const { useLazyOrganisationUnitsTreeLoadQuery, useLazyOrganisationUnitsTreeLoadChildrenQuery } = OrganisationUnitsTreeApi;
